import gsap from 'gsap';
import colors from 'tailwindcss/colors';

import { useGSAP } from '@gsap/react';
import * as React from 'react';

export type Props = {};

const green = colors.green[600];

const SIZE = 80;

gsap.registerPlugin(useGSAP);

function TransformOrigin(props: Props) {
  const {} = props;

  const ref = React.useRef<HTMLDivElement>(null);
  useGSAP(
    () => {
      gsap
        .timeline({
          repeat: -1,
        })
        .add('rotate-wo-to')
        .to('#rect', { duration: 1, rotate: 360 }, 'rotate-wo-to')
        .to('#div', { duration: 1, rotate: 360 }, 'rotate-wo-to');
    },
    {
      scope: ref,
    }
  );

  return (
    <div ref={ref} className="grid grid-cols-2 gap-1">
      <div className="border-gray-600 border">
        <svg>
          <g id="rect" transform="translate(10, 10)">
            <rect width={SIZE} height={SIZE} fill={green}></rect>
            <text alignmentBaseline="hanging">#rect</text>
          </g>
        </svg>
      </div>
      <div className="border-gray-600 border relative">
        <div
          id="div"
          className="absolute bg-green-600"
          style={{
            width: SIZE,
            height: SIZE,
            top: 10,
            left: 10,
          }}
        >
          #div
        </div>
      </div>
    </div>
  );
}

export default React.memo(TransformOrigin);
